import { audit } from "../endpoints/audit.endpoints";
import $axios from "../http/accessor";

interface AuditSettings {
  tax_percent: number;
  expenses_percent: number;
  // Delivery is configured in USD and converted into the buyer's currency.
  delivery_fee_usd: number;
  free_delivery_threshold_usd: number;
}

export interface AuditFilterParams {
  start_date?: string;
  end_date?: string;
  store_id?: string;
  currency_id?: number | null;
}

const AuditService = {
  getSettings: () => $axios.get(audit.settings),

  updateSettings: (data: AuditSettings) => $axios.put(audit.settings, data),

  getOverview: (params: AuditFilterParams) =>
    $axios.get(audit.overview, { params }),

  getPayoutReport: (params: AuditFilterParams) =>
    $axios.get(audit.payoutReport, { params }),

  getTaxReport: (params: AuditFilterParams) =>
    $axios.get(audit.taxReport, { params }),

  getStoreAnalytics: (params: AuditFilterParams) =>
    $axios.get(audit.storeAnalytics, { params }),

  exportPayoutReportCsv: (params: AuditFilterParams) =>
    $axios.get(audit.payoutReport, {
      params: { ...params, format: "csv" },
      responseType: "blob",
    }),

  getStoreAnalyticsReport: (params: AuditFilterParams) =>
    $axios.get(audit.storeAnalytics, { params }),
};

export default AuditService;
